<template>
    <span>
        <slot />
        <el-dialog
            :title="$t('zhiji.knowlege.imExHistoryModal.title')"
            append-to-body
            class="import-model"
            :visible="showEdit"
            @close="showEdit = false"
        >
            <Tabs :tabs-config="tabsConfig" @tabClick="tabClick">
                <component :is="currentComponentName" :status="showEdit" />
            </Tabs>
        </el-dialog>
    </span>
</template>

<script>
import Tabs from "@/views/zhiji/bComponents/switchs/Tabs.vue";
import ImportStatus from "./ImportStatus.vue";
import ExportStatus from "./ExportStatus.vue";
import i18n from "@/i18n";

export default {
    name: "OperationNoteModel",
    components: {
        Tabs,
        ImportStatus,
        ExportStatus
    },
    data() {
        return {
            showEdit: false,
            currentComponentName: "ImportStatus"
        };
    },
    computed: {
        tabsConfig() {
            return [
                {
                    tabName: i18n.t("zhiji.knowlege.imExHistoryModal.importStatus"),
                    contentName: "ImportStatus"
                },
                {
                    tabName: i18n.t("zhiji.knowlege.imExHistoryModal.exportStatus"),
                    contentName: "ExportStatus"
                }
            ];
        }
    },
    mounted() {
        this.$slots.default[0].elm.addEventListener("click", this.openEdit);
    },
    beforeDestroy() {
        this.$slots.default[0].elm.removeEventListener("click", this.openEdit);
    },
    methods: {
        openEdit() {
            this.showEdit = true;
        },
        tabClick(data) {
            this.currentComponentName = data.componentName;
        }
    }
};
</script>

<style lang="less" scoped>
.import-model {
    /deep/.el-dialog {
        width: 65%;
        min-height: 65%;
        max-width: 1200px;
        .el-dialog__body {
            padding: 0;
            .tab-content {
                padding: 15px 12px 20px;
            }
        }
    }
}
</style>
